import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {},
    state: {
        selectedCategory: 0,
        isLoading: false,
        user: JSON.parse(localStorage.getItem("user")),
    },
    getters: {
        auth(state) {
            return state.user;
        }
    },
    mutations: {}
});

export default store;
